module.exports = __webpack_public_path__ + "static/media/trash.17fec9b9.png";